import * as React from 'react';
import PropTypes from 'prop-types';
// import type {Element} from 'react';

const BottomBar: { className: string} = ({className}) => {
    return (
        <div className={className}>
            <div className="inner">
                <p>Powered By: <a href="http://www.partnerize.com">www.partnerize.com</a></p>
            </div>
        </div>
    );
};

BottomBar.propTypes = {
    className: PropTypes.string.isRequired
};

export {BottomBar as default, BottomBar};